import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, Phone } from "lucide-react";
import { useLang } from "../i18n/LangContext";

const CTABand = ({ onOpenForm }) => {
  const { t } = useLang();
  return (
    <section className="py-16 md:py-20" style={{ background: 'linear-gradient(135deg, #D9BA8A 0%, #C9A96E 100%)' }}>
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-8">
          <div className="inline-block px-3 py-1 rounded-full text-xs font-bold mb-3 uppercase tracking-widest" style={{ background: 'rgba(27,42,74,0.15)', color: '#1B2A4A' }}>{t("cta_band.badge")}</div>
          <h2 className="headline-huge text-3xl md:text-5xl text-balance" style={{ color: '#1B2A4A' }}>{t("cta_band.title")}</h2>
          <p className="mt-3 text-base md:text-lg max-w-xl" style={{ color: 'rgba(27,42,74,0.85)' }}>{t("cta_band.subtitle")}</p>
        </div>
        <div className="lg:col-span-4 flex flex-col gap-3">
          <Button onClick={onOpenForm} className="h-14 rounded-full font-semibold inline-flex items-center justify-center gap-2 text-base" style={{ background: '#1B2A4A', color: '#FAF8F5' }}>{t("cta.applyFree")} <ArrowRight className="w-4 h-4" /></Button>
          <a href="tel:+380673461626" className="h-14 rounded-full transition font-semibold inline-flex items-center justify-center gap-2 text-base" style={{ background: 'rgba(255,255,255,0.45)', color: '#1B2A4A' }} data-testid="cta-band-call"><Phone className="w-4 h-4" /> {t("cta.call")}</a>
        </div>
      </div>
    </section>
  );
};

export default CTABand;
